import { call, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { setupIntent } from './api';
import { SETUP_INTENT_STRIPE_REQUEST } from './constants';

function* setup(action) {
  try {
    yield call(removeAPIError);
    const response = yield call(setupIntent);
    action.onSuccess(response.data);
  } catch (error) {
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(SETUP_INTENT_STRIPE_REQUEST, setup);
}

export default function* stripeSagas() {
  yield all([watchList()]);
}
